var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCircleInfo = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0A3847",
  fillRule: "evenodd",
  d: "M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0m0 1.636a7.364 7.364 0 1 0 0 14.728A7.364 7.364 0 0 0 9 1.636m.307 5.728a.92.92 0 0 1 .92.92v4.705a.92.92 0 0 1-.92.92h-.614a.92.92 0 0 1-.92-.92V8.284a.92.92 0 0 1 .92-.92zM9 4.09a1.227 1.227 0 1 1 0 2.455A1.227 1.227 0 0 1 9 4.09",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircleInfo);
export default ForwardRef;